import React from "react";
import mainImg from "../images/product-main.png";
import thumb1 from "../images/thumb1.png";
import thumb2 from "../images/thumb2.png";
import thumb3 from "../images/thumb3.png";
import tick_icon from "../images/tick-icon.png";
import four from "../images/four.png";

const RatingRow = ({ label, valueClass, count }) => (
  <div className="flex items-center gap-3 text-[11px] md:text-xs text-[#6B7280]">

    <div className="flex items-center w-14">
      <span className="mr-1 font-medium">{label}</span>
      <span className="text-[#FACC15] text-[11px]">★</span>
    </div>

    <div className="flex-1 h-2 rounded-full bg-[#F3F4F6] overflow-hidden">
      <div className={`h-full bg-[#FACC15] ${valueClass}`} />
    </div>

    <span className="w-10 text-right">{count}</span>
  </div>
);

const Details = () => {
  return (
    <>
      <section className=" py-10 md:py-14 font-poppins">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="bg-white rounded shadow-md border border-[#E5E7EB] p-5 md:p-8">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">
              <div className="w-full lg:w-[55%]">

                <div className="flex gap-4">

                  <div className="flex justify-between flex-col gap-3 w-24">
                    <div className="rounded overflow-hidden bg-[#FAFAFA]">
                      <img
                        src={thumb1}
                        alt="Thumb 1"
                        className="w-full object-cover"
                      />
                    </div>
                    <div className=" rounded overflow-hidden bg-[#FAFAFA]">
                      <img
                        src={thumb2}
                        alt="Thumb 2"
                        className="w-full object-cover"
                      />
                    </div>
                    <div className="rounded overflow-hidden bg-[#FAFAFA]">
                      <img
                        src={thumb3}
                        alt="Thumb 3"
                        className="w-full object-cover"
                      />
                    </div>
                  </div>

                  <div className="flex-1 rounded bg-[#FAFAFA] flex items-center justify-center">
                    <img
                      src={mainImg}
                      alt="Medicated weight loss"
                      className="w-full max-w-md object-contain p-6"
                    />
                  </div>
                </div>

                <div className="mt-6 border-t border-dashed border-[#E5E7EB]" />

                <div className="mt-10">
                  <h3 className="text-[28px] font-semibold text-[#222222] mb-4">
                    Product Reviews
                  </h3>

                  <div className="mb-4">
                    <div className="flex items-center gap-2">
                      {/* <span className="text-2xl font-semibold text-[#2A3342]">
      4.5
    </span> */}
                      <img
                        src={four}
                        alt="tick"
                        className="mt-1 h-16 w-16 object-contain"
                      />

                      <div className="text-[#FACC15] text-sm leading-none">
                        <div className="block text-[16px]">★★★★★</div>
                        <p className=" block mt-1 text-[12px] text-[#222222]">
                          from 1,25k reviews
                        </p>
                      </div>

                    </div>

                  </div>

                  <div className="space-y-2 mt-8">
                    <RatingRow label="5.0" valueClass="w-[0%]" count="2823" />
                    <RatingRow label="4.0" valueClass="w-[40%]" count="38" />
                    <RatingRow label="3.0" valueClass="w-[12%]" count="4" />
                    <RatingRow label="2.0" valueClass="w-[0%]" count="0" />
                    <RatingRow label="1.0" valueClass="w-[0%]" count="0" />
                  </div>
                </div>
              </div>

              <div className="w-full lg:w-[45%]">

                <h1 className="text-[24px] font-extrabold text-[#222222] mb-3">
                  Medicated Weight Loss Programme
                </h1>

                <div className="flex items-center gap-2 mb-4">
                  <div className="text-[#FACC15] text-base leading-none">
                    ★★★★★
                  </div>
                  <span className="text-sm text-[#4B5563] font-medium">(4900)</span>
                </div>

                <ul className="space-y-2 mb-6 text-[16px] text-[#374151]">
                  <li className="flex items-start gap-2">
                    <img
                      src={tick_icon}
                      alt="tick"
                      className="mt-1 h-5 w-5 shrink-0 object-contain"
                    />
                    <span>
                      Ongoing 1:1 support from our qualified Health Coaches and
                      clinical team
                    </span>
                  </li>
                  <li className="flex items-start gap-2">

                    <img
                      src={tick_icon}
                      alt="tick"
                      className="mt-1 h-5 w-5 shrink-0 object-contain"
                    />
                    <span>
                      Exclusive free access to the UK&apos;s leading GLP-1 tracking
                      and support app, in partnership with WeightWatchers
                    </span>
                  </li>
                  <li className="flex items-start gap-2" style={{ alignItems: "flex-end" }}>

                    <img
                      src={tick_icon}
                      alt="tick"
                      className="mt-1 h-5 w-5 shrink-0 object-contain"
                    />
                    <span>Prices from £85</span>
                  </li>
                </ul>

                <h2 className="text-[18px] font-semibold text-[#222222] mb-3">
                  Price Checker
                </h2>

                <div className="bg-[#FAFAFA] rounded p-4 mb-4">

                  <div className="bg-[#FAFAFA] rounded p-4 mb-4">

                    <div className="pb-3 mb-3">
                      <label className="block text-[16px] font-semibold text-[#2A3342] mb-1">
                        Treatment
                      </label>

                      <select className="w-full bg-white border border-[#E5E7EB] rounded px-3 py-2 text-sm text-[#2A3342] focus:outline-none">
                        <option value="">Select your treatment</option>
                        <option value="semaglutide">Semaglutide</option>
                        <option value="liraglutide">Liraglutide</option>
                        <option value="tirzepatide">Tirzepatide</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-[16px] font-semibold text-[#2A3342] mb-1">
                        Strength
                      </label>

                      <select className="w-full bg-white border border-[#E5E7EB] rounded px-3 py-2 text-sm text-[#2A3342] focus:outline-none">
                        <option value="">Select your dose</option>
                        <option value="low">Low Dose (0.25 mg)</option>
                        <option value="medium">Medium Dose (0.5 mg)</option>
                        <option value="high">High Dose (1 mg)</option>
                      </select>
                    </div>
                    <p className="mt-3 text-[14px] text-[#2A3342]">
                      £85 (4 doses) = £21.25 p/w
                    </p>
                  </div>

                </div>

                <button className="w-full bg-[#56C7D5] hover:bg-[#27AAC0] text-white text-sm font-semibold rounded py-3 transition">
                  Am I eligible?
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* // ===================================/ */}


      <section className="bg-[#FAFAFA] py-14 md:py-16 font-poppins">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <h2 className="text-[48px] font-bold text-[#2A3342] text-center mb-10 md:mb-12">
            You may also like
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">

            <div className="bg-white rounded border border-[#E5E7EB] shadow-sm p-5 flex flex-col">
              <div className="mb-5 flex items-center justify-center">
                <img
                  src={thumb1}
                  alt="Alli Daily Tablets"
                  className="w-full h-40 md:h-[15rem] object-contain"
                />
              </div>

              <div className="flex items-center justify-between mt-5">
                <h3 className="text-[24px] font-semibold text-[#111827]">
                  Alli Daily Tablets
                </h3>
                <span className="text-base md:text-lg font-semibold text-[#111827]">
                  £204.00
                </span>
              </div>

              <p className="mt-2 text-[16px] text-[#374151] leading-relaxed">
                Lorem ipsum dolor sit amet consectetur. Diam sed rhoncus orci vel amet sed at.
                Enim et elit donec nibh ornare mauris pulvinar nec ut.
              </p>
            </div>

            {/* ------------ CARD 2 ------------ */}
            <div className="bg-white rounded border border-[#E5E7EB] shadow-sm p-5 flex flex-col">
              <div className="mb-5 flex items-center justify-center">
                <img
                  src={thumb2}
                  alt="Daily Tablets"
                  className="w-full h-40 md:h-[15rem] object-contain"
                />
              </div>

              <div className="flex items-center justify-between mt-5">
                <h3 className="text-[24px] font-semibold text-[#111827]">
                  Daily Tablets
                </h3>
                <span className="text-base md:text-lg font-semibold text-[#111827]">
                  £204.00
                </span>
              </div>

              <p className="mt-2 text-[16px] text-[#374151] leading-relaxed">
                Lorem ipsum dolor sit amet consectetur. Diam sed rhoncus orci vel amet sed at.
                Enim et elit donec nibh ornare mauris pulvinar nec ut.
              </p>
            </div>

            {/* ------------ CARD 3 ------------ */}
            <div className="bg-white rounded border border-[#E5E7EB] shadow-sm p-5 flex flex-col">
              <div className="mb-5 flex items-center justify-center">
                <img
                  src={thumb3}
                  alt="Daily Tablets"
                  className="w-full h-40 md:h-[15rem] object-contain"
                />
              </div>

              <div className="flex items-center justify-between mt-5">
                <h3 className="text-[24px] font-semibold text-[#111827 ]">
                  Daily Tablets
                </h3>
                <span className="text-base md:text-lg font-semibold text-[#111827]">
                  £204.00
                </span>
              </div>

              <p className="mt-2 text-[16px] text-[#374151] leading-relaxed">
                Lorem ipsum dolor sit amet consectetur. Diam sed rhoncus orci vel amet sed at.
                Enim et elit donec nibh ornare mauris pulvinar nec ut.
              </p>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default Details;
